<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="mb-3">
        <b-form-group label="Nama Level" label-for="Level">
          <b-form-input
            v-model="formData.level.nama_level"
            id="Level"
            readonly
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Timer" label-for="timer">
          <b-form-input v-model="formData.timer" id="timer"></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Output Soal PG" label-for="output_soal_pg">
          <b-form-input
            v-model="formData.output_soal_pg"
            :readonly="level_prof == 3 || level_prof == 4"
            id="output_soal_pg"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Output Soal BS" label-for="output_soal_bs">
          <b-form-input
            v-model="formData.output_soal_bs"
            id="output_soal_bs"
            :readonly="level_prof == 3 || level_prof == 4 || level_prof == 1"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Output Soal MJ" label-for="output_soal_mj">
          <b-form-input
            v-model="formData.output_soal_mj"
            id="output_soal_mj"
            :readonly="level_prof == 3 || level_prof == 4 || level_prof == 1"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Output Soal PGSK" label-for="output_soal_pgsk">
          <b-form-input
            v-model="formData.output_soal_pgsk"
            id="output_soal_pgsk"
            :readonly="level_prof == 2 || level_prof == 4 || level_prof == 1"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Output Soal Text" label-for="output_soal_text">
          <b-form-input
            v-model="formData.output_soal_text"
            id="output_soal_text"
            :readonly="level_prof == 2 || level_prof == 3 || level_prof == 1"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3">
        <b-form-group label="Output Soal BSSK" label-for="output_soal_text">
          <b-form-input
            v-model="formData.output_soal_bssk"
            id="output_soal_text "
            :readonly="level_prof == 2 || level_prof == 4 || level_prof == 1"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="mb-3 float-end">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

export default {
  props: ["level", "selectedData"],
  watch: {
    selectedData: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.formData = newVal;
      }
    },
  },
  emits: ["submitForm"],
  data() {
    return {
      formData: this.$props.selectedData,
      idjadwal: this.$route.params.id,
      level_prof: "",
    };
  },
  mounted() {
    this.level_prof = this.level;
    console.log(this.level_prof);
  },
  methods: {
    shouldDisableOutputSoalPG() {
      // Enable the field if the level is 1 or 2, otherwise disable it
      return this.level_prof !== 1 && this.level_prof !== 2;
    },
    submitForm() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      let payload = { ...this.formData };
      const config = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/jadwal-pelaksanaan/" +
          this.idjadwal +
          "/setup-jadwal/jadwal-timer",
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
        },
      };
      axios(config)
        .then((response) => {
          console.log({ response });
          if (response.data.meta.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: response.data.meta.message,
            });
            this.$emit("submitForm");
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error.response.data);
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: error.response.data.meta.message,
          });
        });
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here if needed */
</style>
